<template>
  <img :class="value"/>
</template>

<script>
import { parseColomnShow } from '../providers/store-parser'
export default {
  name: 'ColumnIconShow',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    getter: {
      type: String,
      required: true
    },
    trans: {
      type: String,
      required: true
    },
    labelClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    value () {
      return parseColomnShow(this.row, this.getter, this.trans)
    }
  }
}
</script>
